import React from "react";
import Card from "components/card";
import { 
    FileText,
 } from "lucide-react";

const JobPostCard = ({recordData, selected, onSelectHandler}) => {

    const onCardClickHandler = () => {
        if(onSelectHandler){
            onSelectHandler(recordData?.jpo_id);
        }
    }

    return (
        <Card
            hoverable
            onClick={onCardClickHandler}
            className={`!rounded-2xl !border-2 transition-all duration-300 cursor-pointer ${
                selected
                    ? "!border-emerald-500  !bg-emerald-50/30"
                    : "!border-slate-200 hover:!border-emerald-300"
                }`}
        >
            <div className="p-4 pb-6">
                <div className="flex items-start gap-3 mb-3">
                    <span 
                        className={`relative flex w-10 h-10 shrink-0 overflow-hidden rounded-full border-2 border-white shadow-md ${
                            selected
                                ? "bg-gradient-to-br from-cyan-500 to-emerald-500"
                                : "bg-cyan-50"
                            }`}
                    >
                        <span className={`flex size-full items-center justify-center ${
                            selected
                                ? "text-white"
                                : "text-emerald-200"
                            }`}
                        >
                            <FileText className="w-5 h-5" />
                        </span>
                    </span>
                    <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-[14px]">
                            {recordData?.jpo_title}
                        </h4>
                        <span className="flex items-center gap-1">
                            <p className="text-xs text-slate-500 m-0">{recordData?.client_name}</p>
                        </span>
                    </div>
                    <span className={`status-indicator mt-1 text-[9px] ${recordData?.status_name?.toLowerCase()}`}>
                        {recordData?.status_name}
                    </span>
                </div>
                <hr className="border-t border-gray-200 mt-3" />
                <div>
                    <div className="flex items-center justify-between">
                        <span className="text-[11px] text-slate-500">
                            Counts
                        </span>
                        <span className=" text-[12px] font-meduim">
                            {recordData?.jpo_count}
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-[11px] text-slate-500">
                            Location
                        </span>
                        <span className=" text-[12px] font-medium">
                            {recordData?.jpo_location}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default JobPostCard;